import React, { useContext, Fragment } from 'react'
import { Link } from 'react-router-dom'
import win from '../../win.svg' 
import { Context } from '../ContextProvider'


function TryAgain() {
    const { quizScore, handleTryAgain } = useContext(Context)

    return (
        <>
            <div className='container result'>
                <img src={win} alt='quiz'/>
                <h2 className='result--heading'>Results</h2>
                <p className='result--text'>{quizScore === 0 ? `You don't have a score yet` : <Fragment>You got <span>{quizScore}</span>correct answer{quizScore === 1 ? "" : "s"}</Fragment>}</p>
                <Link to='/'><button className='result--button' onClick={handleTryAgain}>Try again</button></Link>
            </div>
        </>
    )
}

export default TryAgain